import React, { CSSProperties, useState } from "react";
import ArrowRight from "@assets/images/arrow_right.svg";
import { IPanelItem } from "./PanelItems";

export interface IExpandablePanelItem extends IPanelItem {
  children?: React.ReactNode;
  defaultExpanded?: boolean;
  onToggle?: (expanded: boolean) => void;
}

export const ExpandablePanelItem = (props: IExpandablePanelItem) => {
  const [isExpanded, setIsExpanded] = useState(props.defaultExpanded ?? false);

  // Optional callback when user clicks to expand/collapse
  const handleToggle = () => {
    const newExpanded = !isExpanded;
    setIsExpanded(newExpanded);
    props.onToggle?.(newExpanded);
  };

  const itemStyle: CSSProperties = {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    margin: "0.2vh 0",
    cursor: "pointer",
  };

  const headerStyle: CSSProperties = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontWeight: props?.headerTextStyleCfg?.bold ? "bold" : "normal",
    userSelect: "none",
    whiteSpace: "nowrap",
    margin: "0",
    padding: "0",
  };

  const valueContainerStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  const valueStyle: CSSProperties = {
    margin: 0,
    overflow: "hidden",
    textOverflow: "nowrap",
    fontWeight: props.valueTextStyleCfg?.bold ? "bold" : "normal",
    fontSize: props.valueTextStyleCfg?.largeFont ? "20px" : "18px",
  };

  const arrowStyle: CSSProperties = {
    transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
    transition: "transform 0.2s ease",
    width: "16px",
    height: "16px",
  };

  return (
    <div>
      {/* Main clickable header */}
      <div
        style={itemStyle}
        data-testid={props.testId || "expandableInfoItem"}
        onClick={handleToggle}
      >
        <p style={headerStyle}>{props.header || "HEADER-NOT-SET"}</p>
        <div style={valueContainerStyle}>
          {/* Line Item Value */}
          {typeof props.value === "object" ? (
            props.value
          ) : (
            <p style={valueStyle}>
              {props.value !== null && props.value !== undefined
                ? props.value
                : "VALUE-NOT-SET"}
            </p>
          )}
          {/* Arrow icon rotates when expanded */}
          <img src={ArrowRight} alt="Expand" style={arrowStyle} />
        </div>
      </div>
      {/* Expandable content */}
      {isExpanded && props.children && (
        <div style={{ marginLeft: "1rem", marginTop: "0.5vh" }}>
          {props.children}
        </div>
      )}
    </div>
  );
};
